import moment from 'moment'

export default {
    props: {
        hideTitleYear: false,
    },

    data() {
        return {
            calendarLoading: true,
            hasPage: true,
            view: this.hasPage ? this.page?.user.filters.view : 'month',
            localDate: this.$moment().format('YYYY-MM-DD'),
            calendar: null,
            titleCalender: null,
            viewOptions: {
                gridHeight: 2,
                slotCount: 4,
            },
            setEventsByDay: true,
        }
    },

    mounted() {
        if (!this.hasPage) {
            if (this.loadDate != null) {
                this.localDate = this.loadDate.format('YYYY-MM-DD')
            }
        }
    },

    methods: {
        getCallback(res) {
            let create = false

            if (this.view != this.page.user.filters.view[0] || this.localDate != this.page.user.filters.view[1]) {
                create = true
            }

            this.view = this.page.user.filters.view[0]
            this.localDate = this.page.user.filters.view[1]

            if (this.view == 'week') {
                this.localDate = this.$moment().format('YYYY-MM-DD')
            }

            this._createCalendar()

            return res
        },

        dateToObject(date, isCurrentPeriod = true) {
            return {
                date: date,
                isCurrentPeriod: isCurrentPeriod,
                isToday: moment().isSame(date, 'day'),
                isPast: moment().isAfter(date),
                notInMonth: !moment(date).isSame(this.localDate, 'month'),
                maxCrossOver: this.view == 'day' ? 0 : 8 - date.isoWeekday(),
                weekday: date.isoWeekday(),
                eventCount: this.hasPage
                    ? this.page.data.filter((e) => {
                          return date.isBetween(this.$moment(e.starts_at), this.$moment(e.virtual_ends_at), 'day', '[]')
                      }).length
                    : 0,
                allEvents: this.hasPage
                    ? this.page.data
                          .filter((e) => {
                              return date.isBetween(this.$moment(e.starts_at), this.$moment(e.virtual_ends_at), 'day', '[]')
                          })
                          .sort((a, b) => {
                              return this.$moment(a.starts_at).diff(this.$moment(a.virtual_ends_at), 'day') - this.$moment(b.starts_at).diff(this.$moment(b.virtual_ends_at), 'day')
                          })
                    : [],
                yearEvents: this.events !== undefined ? this.events.find((e) => date.isSame(this.$moment(e.starts_at), 'day')) : null,
                slots: [
                    { value: 'free', event_id: null, width: null },
                    { value: 'free', event_id: null, width: null },
                    { value: 'free', event_id: null, width: null },
                    { value: 'free', event_id: null, width: null },
                    { value: 'free', event_id: null, width: null },
                    // { value: 'free', event_id: null },
                ],
            }
        },

        calendarSetDate(date, view = null) {
            if (view == null) {
                view = this.view
            }

            let newDate = this.$moment(date)
                .startOf(view == 'week' ? 'isoWeek' : view)
                .format('YYYY-MM-DD')

            console.trace('calendarSetDate', newDate)

            this.localDate = newDate

            if (!this.hasPage) {
                this._createCalendar()
                return
            }

            this.page.user.filters.view = [view, newDate]

            this.page.call().updated()
        },

        calendarBack() {
            // this.localDate = moment(this.localDate).subtract(1, this.view)
            // console.log('calendarBack', ! this.hasPage)

            let newDate = this.$moment(moment(this.localDate).subtract(1, this.view))
                .startOf(this.view == 'week' ? 'isoWeek' : this.view)
                .format('YYYY-MM-DD')
            this.localDate = newDate

            if (!this.hasPage) {
                this._createCalendar()
                return
            }

            this.page.user.filters.view = [this.view, newDate]

            this.page.call().updated()
        },

        calendarForward(event) {
            this.localDate = this.$moment(moment(this.localDate).add(1, this.view))
                .startOf(this.view == 'week' ? 'isoWeek' : this.view)
                .format('YYYY-MM-DD')

            if (!this.hasPage) {
                this._createCalendar()
                return
            }

            this.page.user.filters.view = [this.view, this.localDate]

            this.page.call().updated()
        },

        changeView(view) {
            if (!this.hasPage) return

            // console.log('view change', view == 'week' ? 'isoWeek' : view)

            this.page.user.filters.view = [
                view,
                this.$moment()
                    .startOf(view == 'week' ? 'isoWeek' : view)
                    .format('YYYY-MM-DD'),
            ]

            this.page.call().updated()
        },

        _createCalendar() {
            // console.log('_createCalendar');
            this.calendarLoading = true
            this.calendar = []
            this.titleCalender = []

            let date = moment(this.localDate).startOf(this.view == 'week' ? 'isoWeek' : this.view)
            let days = moment(date).daysInMonth()
            let array = [],
                t = null

            if (this.view != 'month') {
                days = this.view == 'week' ? 7 : 1
            }

            if (this.view == 'month') {
                let iso = moment(date).isoWeekday() - 1
                // console.log('iso', iso)

                if (iso >= 1) {
                    for (let x = iso; x > 0; x--) {
                        t = moment(date).subtract(x, 'd')
                        array.push(this.dateToObject(t, false))
                    }
                }
            }

            // if (this.view == 'month') {
            for (let i = 0; i < days; i++) {
                t = moment(date).add(i, 'd')
                array.push(this.dateToObject(t))
            }
            // }

            if (this.view == 'month' && array.length % 7 != 0) {
                for (let i = 0; i < array.length % 7; i++) {
                    t = moment(date).add(days + i, 'd')
                    // console.log('next month date', t.format('DD/MM/YYYY '))
                    array.push(this.dateToObject(t))
                }
            }

            if (this.view == 'month' && array.length / 7 < 6) {
                for (let i = 7; i < 14; i++) {
                    t = moment(date).add(days + i, 'd')
                    // console.log('next month date', t.format('DD/MM/YYYY '))
                    array.push(this.dateToObject(t))
                }
            }

            // if (this.view == 'month') {
            //     this.calendar = array
            // } else {
            //     this.titleCalender = array
            // }
            // have a day by hour calender for the non month views
            // this will allow me to do the multiday sutff on a smaller array

            this.calendar = array
            // console.log('this.view', this.view)
            if (this.setEventsByDay) {
                this._setMultiDayEvents()

                this[this.view == 'month' ? 'calendar' : 'titleCalender'].push(...this.setWeeyAndDay(date, days, [], t))
                this.setSingleDayEvents()
            }

            setTimeout(() => {
                this.calendarLoading = false
            }, 300)
        },

        _setMultiDayEvents() {
            // console.log('setMultiDayEvents', this.calendar.length)
            if (!this.hasPage || this.calendar.length == 0) {
                return
            }

            for (let c = 0; c < this.calendar.length; c++) {
                this.calendar[c].slots = [
                    { value: 'free', event_id: null, width: null },
                    { value: 'free', event_id: null, width: null },
                    { value: 'free', event_id: null, width: null },
                    { value: 'free', event_id: null, width: null },
                    { value: 'free', event_id: null, width: null },
                ]

                this.calendar[c].eventCount = this.page.data.filter((e) => {
                    return (
                        this.$moment(this.calendar[c].date).isSameOrAfter(this.$moment(e.starts_at), 'day') &&
                        this.$moment(this.calendar[c].date).isSameOrBefore(this.$moment(e.virtual_ends_at), 'day')
                    )
                }).length
            }

            // console.log('_setMultiDayEvents')
            // console.log(this.calendar[0].date.format('DD/MM/YYYY'), this.calendar[this.calendar.length-1].date.format('DD/MM/YYYY'))

            this.page.data
                .filter((e) => {
                    return (
                        this.$moment(e.virtual_ends_at).format('YYYY-MM-DD') != this.$moment(e.starts_at).format('YYYY-MM-DD') &&
                        !this.$moment(e.virtual_ends_at).isBefore(this.$moment(this.calendar[0].date, 'day'))
                    )
                })
                .forEach((e) => {
                    let eventDays = Math.ceil(this.$moment(e.virtual_ends_at).diff(this.$moment(e.starts_at), 'day', true))
                    let eventDaysFromCalendarStart = Math.ceil(this.$moment(e.virtual_ends_at).diff(this.$moment(this.calendar[0].date), 'day', true)) + 1
                    let calendarIndexStart = 0,
                        calendarIndexEnd = 0,
                        eventStartsAtMoment = this.$moment(e.starts_at),
                        calendarDay = null,
                        calendarSlotFree = false,
                        slotIndex = 0,
                        isoWeekDay = null,
                        daysRemaining = null,
                        noStart = false,
                        daysInView = this.view == 'day' ? 1 : 7,
                        eventStartDate = this.$moment(e.starts_at).format('YYYY-MM-DD')

                    // calendarIndexStart = this.calendar.findIndex(a => a.date.format('DD/MM/YYYY') == eventStartsAtMoment.format('DD/MM/YYYY'));

                    // if (e.id == 91) {
                    // console.log('daysInView', daysInView)
                    // console.log('cal start', this.$moment(this.calendar[0].date).format('DD/MM/YYYY'))
                    // console.log('start', this.$moment(eventStartDate).format('DD/MM/YYYY'))
                    // console.log('this.$moment(e.starts_at).isBefore(this.calendar[0].date)', this.$moment(eventStartDate).isBefore(this.calendar[0].date))
                    // console.log('--------------------------------------------------------')
                    // }

                    if (this.$moment(eventStartDate).isBefore(this.calendar[0].date)) {
                        eventDays = eventDaysFromCalendarStart
                        calendarIndexStart = 0
                        noStart = true
                    } else {
                        calendarIndexStart = this.calendar.findIndex((c) => c.date.format('DD/MM/YYYY') == this.$moment(eventStartDate).format('DD/MM/YYYY'))
                    }

                    // console.log('this.calendar.length', this.calendar)
                    // if (this.$moment(e.virtual_ends_at).isAfter(this.calendar[this.calendar.length - 1].date)) {
                    // eventDays = this.view == 'month' ? this.calendar.length : (this.view == 'week' ? 6 : 1)
                    // }

                    // console.log('event id', e.id)

                    while (slotIndex < this.viewOptions.slotCount && !calendarSlotFree) {
                        // console.log('slotIndex', slotIndex)
                        calendarSlotFree = true

                        for (let day = 0; day <= eventDays; day++) {
                            let dayIndex = calendarIndexStart + day

                            // console.log({
                            //     eventStartsAtMoment: eventStartsAtMoment.format('DD/MM/YYYY'),
                            //     eventEndsAtMoment: this.$moment(e.virtual_ends_at).format('DD/MM/YYYY'),
                            //     eventDaysFromCalendarStart: eventDaysFromCalendarStart,
                            //     calendarIndexStart: calendarIndexStart,
                            //     dayIndex: dayIndex,
                            //     'this.calendar[dayIndex]': this.calendar[dayIndex]?.date.format('DD/MM/YYYY'),
                            //     slotIndex: slotIndex,
                            //     eventDays: eventDays,
                            // })

                            if (this.calendar[dayIndex] == undefined) {
                                eventDays = day
                                break
                            }

                            if (this.calendar[dayIndex].slots[slotIndex].value != 'free') {
                                calendarSlotFree = false
                                slotIndex++
                                break
                            }
                        }
                    }

                    if (!calendarSlotFree) {
                        return false
                    }

                    for (let calendarIndex = calendarIndexStart; calendarIndex <= calendarIndexStart + eventDays; calendarIndex++) {
                        let value = 'space',
                            width = null,
                            end = false,
                            weekNumber = null,
                            endWeekNumber = null
                        calendarDay = this.calendar[calendarIndex]

                        // if (this.view == week) {

                        // }

                        if (calendarDay == undefined) {
                            // console.log('calendarDay undefined', [calendarIndexStart, calendarIndex, e])
                            break
                        }

                        isoWeekDay = this.$moment(calendarDay.date).isoWeekday() // 1 = monday, 7 = sunday
                        weekNumber = this.$moment(calendarDay.date).isoWeek()
                        endWeekNumber = this.$moment(e.virtual_ends_at).isoWeek()
                        daysRemaining = this.$moment(e.virtual_ends_at).diff(this.$moment(calendarDay.date), 'day')
                        width = (calendarIndex + 1) % daysInView
                        // console.log('width', width)
                        width = width != 0 ? daysInView - width : 0
                        end = weekNumber == endWeekNumber ? true : false

                        if (daysInView == 1) {
                            end = daysRemaining == 0 ? true : false
                        }

                        if (end) {
                            width = daysRemaining
                        }

                        width = 'calc(' + width * -100 + '% - ' + width + 'px)'

                        if (noStart == false && (calendarIndex == calendarIndexStart || this.$moment(eventStartDate).isSameOrAfter(calendarDay.date))) {
                            value = 'start'
                        } else if (isoWeekDay == 1 || daysInView == 1) {
                            value = 'start-again'
                        }

                        // console.log('e.id', e.id)
                        // console.log('calendarDay', this.$moment(calendarDay.date).format('DD/MM/YYYY'))
                        // console.log('calendarIndex', calendarIndex)
                        // console.log('isoWeekDay', isoWeekDay)
                        // console.log('weekNumber', weekNumber)
                        // console.log('endWeekNumber', endWeekNumber)
                        // console.log('daysRemaining', daysRemaining)
                        // console.log('width', width)
                        // console.log('((calendarIndex + 1) % 7)', (calendarIndex + 1) % daysInView)
                        // console.log('Math.ceil(calendarIndex + daysRemaining)', Math.ceil((calendarIndex + daysRemaining) / daysInView))
                        // console.log('Math.ceil(calendarIndex / 7)', Math.ceil(calendarIndex / daysInView))
                        // console.log('end', end)
                        // console.log(calendarIndex == calendarIndexStart, this.$moment(eventStartDate).isSameOrAfter(calendarDay.date))
                        // console.log('value', value)
                        // console.log('--------------------------------------------------------')

                        this.calendar[calendarIndex].slots[slotIndex] = {
                            value: value,
                            event_id: e.id,
                            width: width,
                            end: end,
                        }

                        // this fixes a glitch
                        if (end && daysRemaining == 0) {
                            break
                        }
                    }
                })

            // this.setWeeyAndDay()

            // setTimeout(() => {
            //     this.calendarLoading = false
            // }, 300)
        },

        setSingleDayEvents() {
            if (!this.hasPage) {
                return false
            }

            this.page.data
                .filter((e) => {
                    return this.$moment(e.virtual_ends_at).format('YYYY-MM-DD') == this.$moment(e.starts_at).format('YYYY-MM-DD')
                })
                .forEach((e) => {
                    e.isPast = this.$moment(e.virtual_ends_at).isBefore(this.$moment())

                    let calendarStartDayIndex = this.calendar.findIndex((d) => d.date.isSame(this.$moment(e.starts_at).format('YYYY-MM-DD')))

                    if (calendarStartDayIndex != -1) {
                        for (let slotIndex = 0; slotIndex < this.viewOptions.slotCount; slotIndex++) {
                            if (this[this.view == 'month' ? 'calendar' : 'titleCalender'][calendarStartDayIndex].slots[slotIndex].value == 'free') {
                                this[this.view == 'month' ? 'calendar' : 'titleCalender'][calendarStartDayIndex].slots[slotIndex].value = 'single'
                                this[this.view == 'month' ? 'calendar' : 'titleCalender'][calendarStartDayIndex].slots[slotIndex].event_id = e.id
                                this[this.view == 'month' ? 'calendar' : 'titleCalender'][calendarStartDayIndex].slots[slotIndex].width = '0%'

                                break
                            }
                        }
                    }
                })
        },

        setWeeyAndDay(date, days, array, t) {
            if (this.hasPage && (this.view == 'week' || this.view == 'day')) {
                // console.log(this.page.data.length)

                let startTime = this.page.data
                    .filter((e) => {
                        return this.$moment(e.starts_at).isSame(e.virtual_ends_at, 'day')
                    })
                    .reduce((min, e) => {
                        let hour = parseInt(this.$moment(e.starts_at).format('HH'))
                        return hour < min ? hour : min
                    }, 0)

                let endTime = this.page.data
                    .filter((e) => {
                        return this.$moment(e.starts_at).isSame(e.virtual_ends_at, 'day')
                    })
                    .reduce((min, e) => {
                        let hour = parseInt(this.$moment(e.starts_at).format('HH'))
                        return hour > min ? hour : min
                    }, 24)

                // console.log(startTime)

                for (let h = startTime; h < endTime; h++) {
                    for (let i = 0; i < days; i++) {
                        t = moment(date).add(i, 'd').add(h, 'h')

                        array.push(this.dateToObject(t))
                    }

                    t = moment(date).subtract(7, 'd')
                }
            }

            return array
        },
    },

    computed: {
        calendarTitle() {
            let date = moment(this.localDate).startOf(this.view == 'week' ? 'isoWeek' : this.view)

            if (this.view == 'year') {
                return date.format('YYYY')
            }

            if (this.hideTitleYear) {
                return date.format('MMMM')
            }

            if (this.showYearOnMonthView || (this.view == 'month' && this.setEventsByDay)) {
                return date.format('MMMM YYYY')
            } else if (this.view == 'month') {
                return date.format('MMMM')
            }

            if (this.view == 'week') {
                return date.format('Do') + ' - ' + moment(date).add(6, 'd').format('Do MMMM YYYY')
            }

            return date.format('Do MMMM YYYY')
        },

        calendarTitleMobile() {
            let date = moment(this.localDate).startOf(this.view == 'week' ? 'isoWeek' : this.view)

            if (this.view == 'week') {
                return date.format('Do') + ' - ' + moment(date).add(6, 'd').format('Do MMM YYYY')
            }

            return this.calendarTitle
        },

        titlesWeekDays() {
            if (this.view == 'day') {
                return [this.$moment(this.localDate).format('dd').toUpperCase()]
            }

            return ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN']
        }
    }
}
